<app-productos></app-productos>
<app-formulario-promociones></app-formulario-promociones>
